import React, { useState, Fragment } from 'react';
import { Typography, Box, Divider, Grid, Link, ListItem, ListItemIcon, Tooltip, ListItemText, ClickAwayListener } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { OpenInNew } from '@material-ui/icons';



//UTILITIES
export const addCommas = (num) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

//DATA DISPLAY
export const SubTitle = ({
  variant = 'h6',
  color = 'textPrimary',
  align = 'left',
  value
}) => {
  return (
    <>
      <Typography variant={variant} color={color} align={align}>
        {value}
      </Typography>
      <Box p={1} />
      <Divider />
    </>
  );
};

//Custom tooltip
const TooltipTitle = (props) => {
  const title = props.title;
  return (
    <Fragment>
      <Typography variant="body1" color="inherit">
        {title}
      </Typography>
    </Fragment>
  )
}

export const CustomToolTip = (props) => {
  const { title } = props;
  const [open, setOpen] = useState(false);
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        title={<TooltipTitle title={title} />}
        arrow={true}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        open={open}
        placement="bottom-start">
        <HelpOutlineIcon fontSize="small" color='primary' onClick={() => setOpen(!open)} />
      </Tooltip>
    </ClickAwayListener>
  )
}

const PropertyDetailItem = (props) => {
  const { name, value } = props;

  return (
    <Fragment>
      <Typography variant="h6" color="textPrimary">
        {name.includes('Area') ? addCommas(value) : value}

      </Typography>
      <Typography variant="body2">
        {name}
        {name === 'Net Parcel Area' &&
          <CustomToolTip title="Net parcel area is the gross parcel area recorded with the San Francisco Assessor's Office less any excluded area that does not drain to the SFPUC combined sewer system."/>
        }
        {name === 'Billable Impermeable Area' &&
         <CustomToolTip title="Impermeable area is surface area that prevents the land's natural ability to absorb and infiltrate rainfall or stormwater. Impervious area include, but are not limited to; building or structures, rooftops, impervious concrete and asphalt, and any other continuous watertight pavement or covering. This area is rounded down to the nearest 100 square feet. Standard rate customers are billed on this number." />
        }
        {name === 'Billable Permeable Area' &&
          <CustomToolTip title="Permeable area is surface area that allows stormwater to infiltrate into the ground. Examples include pasture, native vegetation areas, landscape areas, and permeable pavement. The measured permeable area plus the remainder of the impermeable area that was rounded down. Standard rate customers are billed on this number." />
        }
      </Typography>
    </Fragment>
  )
}

export const AreaInformation = (props) => {

  return (
    <Fragment>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom color="primary" align="center" paragraph>
          Property Details
        </Typography>
      </Grid>
      {props && Object.entries(props.data).map(([key, value]) => {
        return (
          <Grid key={key} item xs={props.size ? props.size : 4} align="center">
            <PropertyDetailItem name={key} value={value} />
          </Grid>
        )
      })}
    </Fragment>

  );
};

export const ListItemTextDisplay = ({ text, icon }) => {
  return (
    <ListItem >
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <ListItemText primary={text} />
    </ListItem>
  )
};

export const ListItemLinkDisplay = ({ linkName, href, linkStyle, fontSize, showInfoIcon, externalLink, paddingLeft = '' }) => {
  return (
    <ListItem button style={{ paddingLeft: paddingLeft }}>
      {showInfoIcon &&
        <ListItemIcon>
          <Tooltip title="Click to get more information"><InfoIcon /></Tooltip>
        </ListItemIcon>}
      <Link href={href} target='_blank' rel='noreferrer' className={linkStyle} style={{ fontSize: fontSize }}>{linkName}</Link>
      {externalLink && <OpenInNew fontSize='inherit' />}
    </ListItem>
  )
};

export const LinkTextDisplay = ({ linkName, href, linkStyle, fontSize, externalLink }) => {
  return (
    <>
      <Link href={href} target='_blank' rel='noreferrer' className={linkStyle}>
        {linkName}
      </Link>
      {externalLink && <OpenInNew fontSize='inherit' />}
    </>
  )
};